
import './tailwind.css';
// Namespaced Tailwind rules for myConversations (scoped under .my-conversations)
import './components/myConversations/myconversations-tailwind.css';

// Always redirect '/' to '/auth' before any app logic runs
if (window.location.pathname === '/') {
  window.location.replace('/auth');
} else {
  const path = window.location.pathname.replace('/', '');
  const page = path || 'auth';

  switch (page) {
    case 'auth':
      require('./container/auth');
      break;
    case 'account':
      require('./container/home');
      break;
    case 'notAvailable':
      require('./container/notAvailable');
      break;
    case 'forgotPassword':
      require('./container/resetPassword');
      break;
    case 'activationExpired':
      require('./container/activationExpired');
      break;
    case 'email':
      require('./container/email');
      break;
    case '404':
      require('./container/404');
      break;
    case 'viewEmail':
      require('./container/viewEmail');
      break;
    case 'user-activation':
      require('./container/userActivation.js');
      break;
  }
}
